import { render } from "./ButtonSendDataSelfService.vue?vue&type=template&id=60a7d4d8"
import script from "./ButtonSendDataSelfService.vue?vue&type=script&lang=js"
export * from "./ButtonSendDataSelfService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__